export default __webpack_public_path__ + "static/media/Figtree-Medium.c2ac9359.ttf";